import { render, staticRenderFns } from "./LockAccountSwitch.vue?vue&type=template&id=990f69dc&"
import script from "./LockAccountSwitch.vue?vue&type=script&lang=js&"
export * from "./LockAccountSwitch.vue?vue&type=script&lang=js&"
import style0 from "./LockAccountSwitch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports